import { Navigate, NavLink, Route, Routes } from "react-router";
import { adminApi } from "../api";
import { CompaniesTab } from "./admin/CompaniesTab";
import { DictionaryTab } from "./admin/DictionaryTab";

/**
 * Справочники — доступны всем авторизованным (логист и админ).
 * По требованию заказчика перевозчиков, проекты и типы транспорта ведут сами логисты.
 */
const TABS = [
  { path: "companies", label: "Перевозчики" },
  { path: "projects", label: "Проекты" },
  { path: "vehicle-types", label: "Типы транспорта" },
] as const;

export function DirectoryPage() {
  return (
    <>
      <div className="page-header">
        <h1>Справочники</h1>
      </div>
      <nav className="tabs">
        {TABS.map((t) => (
          <NavLink key={t.path} to={`/directory/${t.path}`}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route index element={<Navigate to="/directory/companies" replace />} />
        <Route path="companies" element={<CompaniesTab />} />
        <Route
          path="projects"
          element={
            <DictionaryTab
              title="Проекты"
              placeholder="Название проекта"
              emptyText="Проектов пока нет. Без проекта нельзя создать заявку — добавьте хотя бы один."
              load={adminApi.projects}
              create={adminApi.createProject}
              update={adminApi.updateProject}
            />
          }
        />
        <Route
          path="vehicle-types"
          element={
            <DictionaryTab
              title="Типы транспорта"
              placeholder="Например: Тент 20 т"
              emptyText="Типов транспорта пока нет."
              load={adminApi.vehicleTypes}
              create={adminApi.createVehicleType}
              update={adminApi.updateVehicleType}
            />
          }
        />
        <Route path="*" element={<Navigate to="/directory/companies" replace />} />
      </Routes>
    </>
  );
}
